var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { map, tap, withLatestFrom, filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ADMIN_ROLE } from '@careapp/core';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import * as actions from '../actions/index';
import * as selectors from '../reducers/index';
var RouterEffects = /** @class */ (function () {
    function RouterEffects(store, actions$, router, route) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.router = router;
        this.route = route;
        this.navigate$ = this.actions$
            .ofType(actions.GO).pipe(map(function (action) { return action.payload; }), tap(function (_a) {
            var path = _a.path, queryParams = _a.query, extras = _a.extras;
            return _this.router.navigate(path, __assign({ queryParams: queryParams }, extras));
        }));
        this.organisationCreated = this.actions$
            .ofType(actions.Organisations.RESPONSE_SUCCESS_CREATE).pipe(tap(function (action) {
            _this.router.navigate(['/', 'admin', 'organisations']);
        }));
        this.routerEffects = this.actions$
            .ofType(ROUTER_NAVIGATION).pipe(withLatestFrom(this.store.select(selectors.isAppAuthorized), this.store.select(selectors.getRouterState), this.store.select(selectors.getSelectedId('organisations')), this.store.select(selectors.auth.isAdmin), this.store.select(selectors.org.getSelectableIds)), filter(function (_a) {
            var _ = _a[0], auth = _a[1];
            return !!auth;
        }), tap(function (_a) {
            var action = _a[0], authorized = _a[1], router = _a[2], selectedOrganisation = _a[3], admin = _a[4], orgIds = _a[5];
            if (router.state) {
                switch (router.state.url) {
                    case '/': {
                        if (selectedOrganisation) {
                            _this.store.dispatch(actions.NavigateAction({
                                path: ['/', 'organisations', selectedOrganisation]
                            }));
                        }
                        else if (admin) {
                            _this.store.dispatch(actions.NavigateAction({ path: ["/admin"] }));
                        }
                        else {
                            _this.store.dispatch(actions.NavigateAction({
                                path: ["/organisations", orgIds[0]]
                            }));
                        }
                    }
                }
            }
        }));
        this.initialRedirect = this.actions$
            .ofType(actions.APPLICATION_READY).pipe(withLatestFrom(this.store.select(selectors.getRouterState), this.store.select(selectors.getAuthenticationState), this.store.select(selectors.getSelectedId('organisations')), this.store.select(selectors.org.getSelectableIds)), tap(function (_a) {
            var action = _a[0], router = _a[1], auth = _a[2], orgId = _a[3], orgIds = _a[4];
            orgId = orgId || orgIds[0];
            if (!router || (router.state && router.state.url !== '/auth' && !auth.auth)) {
                return _this.store.dispatch(actions.NavigateAction({
                    path: ['/', 'auth'],
                    extras: { skipLocationChange: true, replaceUrl: true }
                }));
            }
            if (router.state &&
                router.state.url &&
                !router.state.url.match(/auth$/) &&
                router.state.url !== '/') {
                return;
            }
            if (auth.roles && auth.roles.find(function (value) { return value === ADMIN_ROLE; })) {
                _this.router.navigate(['/admin']);
            }
            else if (orgId) {
                _this.router.navigate(['/organisations', orgId]);
            }
            else {
                console.log('No organisation information available - falling back to login');
                actions.NavigateAction({
                    path: ['/', 'auth']
                });
            }
        }));
        this.customerCreated = this.actions$.ofType(actions.Customers.RESPONSE_SUCCESS_CREATE).pipe(tap(function (action) {
            _this.router.navigate(['/organisations', action.payload.organisationId, 'customers']);
        }));
        this.redirectToLogin = this.actions$
            .ofType(actions.RESPONSE_SUCCESS_AUTH_LOGOUT, actions.RESPONSE_FAIL_AUTH_LOGOUT).pipe(tap(function (action) { return _this.router.navigate(['/', 'auth']); }));
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "navigate$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "organisationCreated", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "routerEffects", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "initialRedirect", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "customerCreated", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], RouterEffects.prototype, "redirectToLogin", void 0);
    return RouterEffects;
}());
export { RouterEffects };
